<template>
   <v-col  class="col-md-6 col-6">
    <v-card>
      <v-img  :src="src"  class="grey lighten-2" style="width: 181px;height: 194px;">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-card-text>
        <v-row>
          <v-col cols="10" class="pb-0">{{ title }}</v-col>
          <v-col cols="2" class="pb-0 text-right">
            <v-row>
              <v-col cols="6">
                <edit :Src="src" :NameCEO="title" :Position="position" :Catchphrase="catchphrase" :id="id"></edit>
              </v-col>
              <v-col cols="6">
                <v-btn icon color="red" @click="DeleteConfirmdialog=true;" class="btn-card">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0">{{ position }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0">{{ catchphrase }}</v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="DeleteConfirmdialog" persistent max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          แน่ใจหรือว่าต้องการลบ?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="DeleteConfirmdialog = false">
            ยกเลิก
          </v-btn>
          <v-btn color="green darken-1" text @click="Delete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="DeleteCompletedialog" persistent max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          ลบข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DeleteCompletedialog = false;$emit('updatelist')">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-col>
</template>

<script>
import Edit from './edit';
export default {
  components: {
      Edit
    },
  name: "Card",
  props: {
    title: String,
    src: String,
    position: String,
    catchphrase: String,
    id: Number
  },
  data() {
    return {
      DeleteConfirmdialog:false,
      DeleteCompletedialog:false,
    };
  },
  methods: {
    Delete(){
      this.$store.commit('set_overlay',true);
        this.DeleteConfirmdialog = false;
        let formData = new FormData();
            formData.append('id',this.id);
        this.req.post(this.$store.getters.base_api + 'delete-ceo',formData).then(response=>{
          this.DeleteCompletedialog = true;
        }).catch(error => {
          this.$store.commit('set_overlay',false);
        });
    },
  },
  mounted() {
    this.req = this.$store.getters.req;
  },
};
</script>
<style type="text/css">

.btn-card.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #ff000000 !important;
    color: #fff;
}
</style>